/**
 * Chromatic chart series — shared by Recharts, SVG, and CSS progress bars.
 * Keep hexes aligned with theme-runtime `--color-an-chart-*`.
 * Prefer these helpers over `--color-an-primary` for data graphics
 * (primary is charcoal chrome; series colors are the accent stage).
 */
import type { CSSProperties } from 'react';

export const ADMIN_CHART_SERIES_HEX = [
  '#3b82f6', // 1 blue
  '#14b8a6', // 2 teal
  '#f59e0b', // 3 amber
  '#ef4444', // 4 red
  '#a855f7', // 5 purple
  '#06b6d4', // 6 cyan
  '#ec4899', // 7 pink
  '#84cc16', // 8 lime
] as const;

export type AdminChartSeriesIndex = 0 | 1 | 2 | 3 | 4 | 5 | 6 | 7;

export function adminChartHex(index: number): string {
  const palette = ADMIN_CHART_SERIES_HEX;
  return palette[((index % palette.length) + palette.length) % palette.length] ?? palette[0];
}

/** Inline fill for ranked / funnel CSS width bars (same series as charts). */
export function adminChartBarStyle(
  index: number,
  widthPct: number,
  extras?: Readonly<CSSProperties>,
): CSSProperties {
  return {
    backgroundColor: adminChartHex(index),
    width: `${String(Math.max(0, Math.min(100, widthPct)))}%`,
    ...extras,
  };
}

/** Soft left→right gradient for product/category share bars. */
export function adminChartBarGradientStyle(
  index: number,
  widthPct: number,
): CSSProperties {
  const to = adminChartHex(index);
  const from = adminChartHex(index + 1);
  return {
    backgroundImage: `linear-gradient(90deg, ${from} 0%, ${to} 100%)`,
    width: `${String(Math.max(0, Math.min(100, widthPct)))}%`,
  };
}
